var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    clipPath: "url(#clip0_0_14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Circle",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF2D55"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bang"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 10.6575C8.3775 10.6575 7.875 10.155 7.875 9.5325V4.8375C7.875 4.215 8.3775 3.7125 9 3.7125C9.6225 3.7125 10.125 4.215 10.125 4.8375V9.5325C10.125 10.155 9.6225 10.6575 9 10.6575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 14.5125C8.685 14.5125 8.3775 14.385 8.1525 14.16C7.9275 13.935 7.8 13.6275 7.8 13.3125C7.8 12.9975 7.9275 12.69 8.1525 12.465C8.43 12.1875 8.85 12.06 9.2325 12.135C9.3075 12.15 9.39 12.1725 9.4575 12.2025C9.5325 12.2325 9.6 12.27 9.6675 12.315C9.735 12.36 9.795 12.405 9.8475 12.465C10.0725 12.69 10.2 12.9975 10.2 13.3125C10.2 13.6275 10.0725 13.935 9.8475 14.16C9.6225 14.385 9.315 14.5125 9 14.5125Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeWarning);
export default __webpack_public_path__ + "static/media/badge_warning.8c2cc9bbed890afb7de587d393c8bb1e.svg";
export { ForwardRef as ReactComponent };